import { FormControl, InputAdornment, SxProps, TextField, Theme } from "@mui/material"
import SearchIcon from '@mui/icons-material/Search'
import { useRef, useState } from "react"

interface SearchbarProps {
    text: string
    setText: (x: string) => void
    debounce: number
    placeholder?: string
    sx?: SxProps<Theme>
}

export const Searchbar = ({ text, setText, debounce, placeholder, sx }: SearchbarProps) => {

    const [searchText, setSearchText] = useState(text)
    const debounceTimer = useRef<NodeJS.Timeout | null>(null)

    const handleSearchTextChange = (e: string) => {
        setSearchText(e)
        const timeout = setTimeout(() => {
            if (debounceTimer.current !== timeout) {
                return
            }
            setText(e)
        }, debounce)
        debounceTimer.current = timeout
    }

    return (
        <FormControl sx={sx} fullWidth variant='outlined'>
            <TextField slotProps={{
                input: {
                    endAdornment: (
                        <InputAdornment position='end' >
                            <SearchIcon />
                        </InputAdornment>
                    )
                }
            }} variant='outlined' fullWidth value={searchText} onChange={e => handleSearchTextChange(e.target.value)} placeholder={placeholder} />
        </FormControl>
    )
}